export enum UsersRequestRoutes {
  USER_ACTIVATE = "/api/admin/activate-user",
  USER_DEACTIVATE = "/api/admin/deactivate-user",
  USER_UNLOCK = "/api/admin/unlock-user",
}
